// extracted by mini-css-extract-plugin
module.exports = {"fallbackLayout":"fallbackLayout_fallbackLayout__23YXn"};